import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from './styles';

const PageContent = ({ children, ...props }) => (
  <Wrapper {...props}>{children}</Wrapper>
);

PageContent.propTypes = {
  children: PropTypes.node,
};

PageContent.defaultProps = { children: null };

export default PageContent;
